module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-6.jpg?9b5aac33";